"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncList = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_content_loader_1 = tslib_1.__importDefault(require("react-content-loader"));
var LoadingMask_1 = require("../LoadingMask");
var List_1 = require("./List");
/**
 * @internal
 */
function AsyncList(props) {
    var className = props.className, width = props.width, height = props.height, items = props.items, itemHeight = props.itemHeight, renderItem = props.renderItem, isLoading = props.isLoading, _a = props.nextPageItemPlaceholdersCount, nextPageItemPlaceholdersCount = _a === void 0 ? 0 : _a, isLoadingNextPage = props.isLoadingNextPage, onLoadNextPage = props.onLoadNextPage;
    var itemRenderer = react_1.useCallback(function (renderItemProps) {
        if (renderItemProps.rowIndex + 1 > items.length) {
            return react_1.default.createElement(LoadingPlaceholder, null);
        }
        return renderItem(renderItemProps);
    }, [items, renderItem]);
    var handleScrollEnd = react_1.useCallback(function (_, endRowIndex) {
        if (endRowIndex > items.length && !isLoadingNextPage) {
            onLoadNextPage === null || onLoadNextPage === void 0 ? void 0 : onLoadNextPage();
        }
    }, [items, isLoadingNextPage, onLoadNextPage]);
    return isLoading ? (react_1.default.createElement(LoadingMask_1.LoadingMask, { height: props.height })) : (react_1.default.createElement(List_1.List, { className: classnames_1.default("gd-async-list", className ? className : ""), width: width, height: height, items: items, itemHeight: itemHeight, itemsCount: items.length + nextPageItemPlaceholdersCount, renderItem: itemRenderer, onScrollEnd: handleScrollEnd }));
}
exports.AsyncList = AsyncList;
function LoadingPlaceholder() {
    return (react_1.default.createElement("div", { className: "gd-list-item gd-list-item-not-loaded" },
        react_1.default.createElement(react_content_loader_1.default, { viewBox: "0 0 250 28" },
            react_1.default.createElement("rect", { x: "0", y: "7", rx: "3", ry: "3", width: "13", height: "13" }),
            react_1.default.createElement("rect", { x: "22", y: "7", rx: "3", ry: "3", width: "250", height: "13" }))));
}
//# sourceMappingURL=AsyncList.js.map